import { render, staticRenderFns } from "./threeBarChart.vue?vue&type=template&id=40230a2c&scoped=true&"
import script from "./threeBarChart.vue?vue&type=script&lang=js&"
export * from "./threeBarChart.vue?vue&type=script&lang=js&"
import style0 from "./threeBarChart.vue?vue&type=style&index=0&id=40230a2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40230a2c",
  null
  
)

export default component.exports